var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHash = function SvgHash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "36.561px",
    height: "36.561px",
    viewBox: "0 0 36.561 36.561",
    enableBackground: "new 0 0 36.561 36.561",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-hashtag",
    fill: "currentColor",
    fillOpacity: 0.85,
    d: "M35.963,12.25l0.583-3.266c0.095-0.531-0.26-1.04-0.792-1.136 c-0.058-0.01-0.114-0.015-0.172-0.015h-6.106L30.67,1.15c0.095-0.531-0.26-1.04-0.792-1.136c-0.058-0.01-0.114-0.015-0.172-0.015 H26.39c-0.475,0-0.881,0.34-0.964,0.807l-1.255,7.027h-8.05l1.191-6.685c0.096-0.531-0.261-1.04-0.793-1.135 C16.464,0.005,16.407,0,16.35,0h-3.314c-0.476,0-0.882,0.34-0.966,0.807l-1.255,7.027H4.361c-0.474,0-0.88,0.34-0.964,0.807 l-0.583,3.266c-0.095,0.531,0.261,1.039,0.792,1.136c0.058,0.01,0.114,0.015,0.172,0.015h6.105L8.017,23.504H1.562 c-0.475,0-0.881,0.34-0.964,0.807l-0.582,3.266c-0.096,0.531,0.259,1.041,0.791,1.136c0.057,0.011,0.115,0.016,0.173,0.016h6.105 L5.891,35.41c-0.095,0.531,0.26,1.04,0.792,1.136c0.058,0.01,0.114,0.015,0.172,0.015h3.316c0.476,0,0.882-0.342,0.964-0.811 l1.255-7.027h8.05l-1.191,6.688c-0.097,0.531,0.259,1.04,0.791,1.136c0.058,0.01,0.114,0.015,0.173,0.015h3.314 c0.478,0,0.884-0.342,0.966-0.811l1.255-7.027H32.2c0.474,0,0.88-0.34,0.964-0.807l0.583-3.266c0.095-0.531-0.261-1.04-0.792-1.136 c-0.058-0.01-0.114-0.015-0.172-0.015h-6.105l1.865-10.446H35c0.475,0,0.881-0.34,0.964-0.807L35.963,12.25z M21.373,23.504h-8.051 l1.864-10.446h8.049L21.373,23.504z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hash.ea337647.svg";
export { ForwardRef as ReactComponent };